import { zodResolver } from '@hookform/resolvers/zod';
import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';

import type { SingleBillInfoFormData, SingleBillInfoFormHandlers } from '@ctct/application-layer';
import { Button } from '@ctct/payflow-ui';
import { Col, Container, FormWrapper, Row } from '@ctct/presentation-layer';
import type { SingleBillInfoFormHooks } from '@ctct/state-client-layer';

import { SingleBillInfoCard } from './components/SingleBillInfoCard';
import { FormWithinContext } from './FormWithinContext';

import './single-bill-form-widget-content.scss';

interface Props {
  data: SingleBillInfoFormData;
  handlers: SingleBillInfoFormHandlers;
  hooks: SingleBillInfoFormHooks;
}

export const SingleBillInfoFormWidgetContent = ({ data, handlers, hooks }: Props) => {
  const { t } = useTranslation();

  const isLoading = hooks.useIsLoading();
  const isDisplayingCard = hooks.useIsDisplayingCard();
  const canDisplayCard = hooks.useCanDisplayCard();

  if (isDisplayingCard) {
    return <SingleBillInfoCard data={data} handlers={handlers} hooks={hooks} />;
  }

  return (
    <div className="single-bill-info-form">
      <FormWrapper
        onSubmit={noop}
        loading={isLoading}
        values={data.getDefaultValues()}
        resolver={zodResolver(data.getZodSchema())}
      >
        <FormWithinContext data={data} handlers={handlers} hooks={hooks} />
      </FormWrapper>

      {canDisplayCard && (
        <Container>
          <Row>
            <Col />
            <Col fixed>
              <Button variant="text" onClick={handlers.onCancelClick} className="single-bill-info-form__cancel-button">
                {t('single-bill-info-form.cancel')}
              </Button>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};
